import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21eaa024&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21eaa024')) {
      api.createRecord('21eaa024', component.options)
    } else {
      api.reload('21eaa024', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21eaa024&", function () {
      api.rerender('21eaa024', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/kl-xiaodai/index/index.vue"
export default component.exports